import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Flex, Loading, Text } from "@paguelofacil/pf-components";

import { language, languageDefault } from "../services/utils/Language";

import { InputTextEmail } from "./Inputs/Email";
import { PhoneInput } from "./Inputs/Phone";
import { ManageService } from "../services/Services";

const PaymentSdkForm = ({ intl, handle, user }) => {
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async event => {
        setIsLoading(true);
        event.preventDefault();
        const responseService = await ManageService.getValidateEmailZinli(email, phone);

        if (responseService) {
            handle(email, phone);
        }

        setEmail("");
        setPhone("");
        setIsLoading(false);
    };

    const shouldDisabledButtonNext = !email || !phone;

    const placeholderPhone = intl.formatMessage({
        id: language.enter_number,
        defaultMessage: languageDefault.enter_number,
    });

    return (
        <Loading isLoading={isLoading}>
            <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                <Flex gap="1.25rem" direction="column">
                    <InputTextEmail
                        defaultValue={user?.email}
                        label={<FormattedMessage id={language.email} defaultMessage={languageDefault.email} />}
                        name="email"
                        placeholder="correo.user@mail.com"
                        onChangeValue={setEmail}
                        isRequired={true}
                    />
                    <PhoneInput
                        label={<FormattedMessage id={language.phone} defaultMessage={languageDefault.phone} />}
                        onChange={setPhone}
                        country="PA"
                        placeholder={placeholderPhone}
                        isRequired={true}
                    />
                    <Button
                        className="button-primary-cf"
                        fullWidth
                        size="md"
                        type="submit"
                        style={{ marginTop: "1.25rem" }}
                        disabled={shouldDisabledButtonNext}
                    >
                        <FormattedMessage id={language.next} defaultMessage={languageDefault.next} />
                    </Button>
                    <Text variant="caption" weight="regular" style={{ maxWidth: "46rem" }}>
                        <FormattedMessage
                            id={language.first_term_conditions}
                            defaultMessage={languageDefault.first_term_conditions}
                        />
                        &nbsp;
                        <a href="http://www.paguelofacil.com/terminos-y-condiciones/" target="_blank" rel="noreferrer">
                            <FormattedMessage
                                id={language.term_conditions}
                                defaultMessage={languageDefault.term_conditions}
                            />
                        </a>
                        &nbsp;
                        <FormattedMessage
                            id={language.second_term_conditions}
                            defaultMessage={languageDefault.second_term_conditions}
                        />
                    </Text>
                </Flex>
            </form>
        </Loading>
    );
};

export default PaymentSdkForm;
